import { render, staticRenderFns } from "./LanguageHeaderThemes.vue?vue&type=template&id=2064b3fe&scoped=true"
import script from "./LanguageHeaderThemes.vue?vue&type=script&lang=ts"
export * from "./LanguageHeaderThemes.vue?vue&type=script&lang=ts"
import style0 from "./LanguageHeaderThemes.vue?vue&type=style&index=0&id=2064b3fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064b3fe",
  null
  
)

export default component.exports